import { render } from "./ButtonsComponent.vue?vue&type=template&id=41c27ca7&scoped=true&ts=true"
import script from "./ButtonsComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonsComponent.vue?vue&type=script&lang=ts"

import "./ButtonsComponent.vue?vue&type=style&index=0&id=41c27ca7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c27ca7"]])

export default __exports__